<script lang="ts">
  import { onMount } from 'svelte';
  import type { PaginateResult } from '../../types/paginate';
  import type { Report } from '../../modules/report/report.interface';
  import { ProjectConfigService, ReportService } from '../../modules';
  import ProjectReportListPaginate from './ProjectReportListPaginate.svelte';
  import ProjectReportCreate from './ProjectReportCreate.svelte';
  import Page from '../Page.svelte';

  export let params: { project: string };

  const projectConfig = ProjectConfigService.get(params.project);
  let reportsInfoResponse: PaginateResult<Report>;
  let latestReport: Report;

  onMount(fetchReports);

  async function fetchReports() {
    const { page = 1, limit = 10 } = reportsInfoResponse || {};
    reportsInfoResponse = await ReportService.getList(projectConfig.key, {
      page,
      limit,
    });

    if (page === 1) {
      latestReport = reportsInfoResponse.docs?.[0];
    }
  }
</script>

<Page>
  <div slot="header">
    {#if reportsInfoResponse}
      <ProjectReportCreate {latestReport} {projectConfig} />
    {/if}
  </div>
  {#if reportsInfoResponse}
    <ProjectReportListPaginate {reportsInfoResponse} {projectConfig} />
  {/if}
</Page>
